module.exports = __webpack_public_path__ + "img/support.b4f2a6f6.svg";